import React, {Component} from 'react'
import {Link} from 'gatsby'

import { WebsiteIcon } from '@epi/epi-ui/es/websites'

import './MakeNetSafe.scss'

class MakeNetSafe extends Component {

    render () {
        const node = this.props.node

        return (
            <div className="MakeNetSafe">
                <div className="MakeNetSafe-content">
                    <div className="MakeNetSafe-main-content">
                        <div className="MakeNetSafe-mast">
                            <div>
                                Make
                            </div>
                            <div>
                                Net
                            </div>
                            <div>
                                Safe
                            </div>
                        </div>
                        <h1 className="MakeNetSafe-title">
                            <div>
                                Make
                            </div>
                            <div>
                                The
                            </div>
                            <div>
                                Net
                            </div>
                            <div>
                                Safe
                            </div>
                        </h1>
                    </div>

                    <p>
                        The internet <strong>isn't safe</strong>.
                    </p>

                    <p>
                        We've been sleepwalking into <strong>disastrous negligence</strong>.
                    </p>

                    <p>
                        We all know it now, but we still <strong>haven't decided how to fix it</strong>.
                    </p>

                    <p>
                        We're under attack, on many fronts. <strong>Phishing</strong>, <strong>scams</strong> and <strong>dangerous content</strong> plague daily life. We have to be on <strong>high alert</strong> at all times to dodge threats.
                    </p>

                    <p>
                        It <strong>only takes a click to end up in danger</strong>, to land on a bad site. Why should this be the case?
                    </p>

                    <p>
                        <strong>In its early days, the internet was an alternative way of doing things</strong>. It was defined by not being the real world (or IRL).
                    </p>

                    <p>
                        <strong>But now, the internet is the definitive way of doing things</strong>. It is impossibly hard to live without it. <strong>It is the real world</strong>. 
                    </p>

                    <p>
                        But <strong>we haven't brought people with us</strong>. It's a technocratic two-tier world of those who know how the internet works, and those who don't. Those of us who are not digital natives are especially vulnerable to attacks.
                    </p>

                    
                    <p>
                        <strong>NSFW?</strong> The net's <strong>not safe for work</strong>, but also <strong>not safe for children</strong>, or <strong>for life</strong>.
                    </p>
  

                    <p>
                        <strong>Phishing</strong>, the attack which exploits brand trust and convinces you to provide credentials to a malicious actor, <strong>is the leading cyber attack</strong>.
                    </p>

                    

                    <p>
                        <strong>The technology of the internet, the web and web browsers hasn't substantially changed since the 1990s</strong>. They are all underpinned by identifiers that don't work for people. <strong>URLs</strong> (web addresses), <strong>domain names</strong>, <strong>IP addresses</strong>. They're technically focused. They're not human friendly. 
                    </p>





                    <p>
                        The <strong>internet is still a frontier</strong>. The <strong>web is a World Wild West</strong>.
                    </p>

                    {/* <p>
                        A world increasingly of free agents. Creators. Influencers. 
                    </p> */}

                    <p>
                        {/* Trust is being eroded around the world. Trust in organisations and authorities is under threat. In organisations.  */}

                        <strong>Trust is under threat</strong> around the world. Trust in organisations and authorities is not guaranteed.

                        {/* Trust in authorities, in organisations, and in the internet, trust is under threat. In organisations.  */}
                    </p>

                    <p>
                        Trust is ever crucial in a world of uncertainty and danger. But <strong>gauging trust on the internet is ever demanding</strong>.
                    </p>

                    {/* <p>
                        Trust is the word of the century.
                    </p> */}

                    



                    <p>
                        Compared with the physical world, the <strong>internet is a level playing field</strong> with equal opportunity for accessing and sharing pages and content. However, there is little expression of authority; it is <strong>hard to know who and what to trust</strong>. 
                    </p>

                    
                    <p>
                        <strong>With the web, the key trust indicator is the URL and the domain within</strong>. But <strong>anyone can register a domain name</strong> for little cost and use it in a malicious lookalike campaign to masquerade a brand of their choice or target specific users.
                    </p>
                    <p>
                        <strong>Users tend to find it hard to determine whether a site is official and legitimate</strong>. Too often, people accept the purported authority by way of the supposed brand, copycat design and the imposition of panic, and get phished.

                        {/* Trust is hard to gauge on the web. */}
                    </p>

                    {/* for those that reject traditional media */}



                    <p>
                        Consider the URLs <br/><code>"https://login·facebook·com"</code> and <br/><code>"https://login-facebook·com"</code>. So <strong>subtly different</strong>, but with <strong>massive trust implications</strong>. The former is on the official Facebook website, the latter is not on <code>"facebook·com"</code> but another domain entirely, and not an official Facebook domain.
                    </p>

                    <p>
                        <strong>Domains aren't always a perfect match for brands</strong>. It's about who purchases the domain registration first (and continues renewals). <em>Aside: A company might have a trademark and this can help acquiring an existing domain but only if the company is older and they have the trademark before the domain in question!</em>
                    </p>

                    <p>
                        It's <strong>not always possible for a company to get the most appropriate domain</strong>.
                        
                        Take the URL for Metro Bank in the UK: <code>"https://www·metrobankonline·co·uk"</code>. The official domain looks less authentic than <code>"metrobank·co·uk"</code>, which is not Metro Bank.
                    </p>

                    <p>
                        With exhaustion of the dot-com space in the domain name system (DNS), <strong>how are startups and newly established companies meant to get a perfect or even good domain?</strong>
                    </p>

                    <p>
                        <strong>Organisations also tend to use a number of domains</strong> for their various functions, and we've found that a significant number of sites, including banks, are hosting login and authentication on an entirely different domain to their main site. This is problematic for trust, and makes phishing and fraud easier.
                    </p>

                    <p>
                        <strong>How are we meant to know a URL corresponds to a brand?</strong> We try to remember domains and take a guess. This isn't good enough.
                    </p>

                    <p>
                        There's <strong>no verifiable pairing of domain names to official organisation names</strong>. We have search engines, but these are susceptible to abuse via results and ads.
                    </p>

                    <p>
                        So far, <strong>industry and institutions are reactive to threats</strong>, reactive to malicious websites; they are not proactive, <strong>not proactive to creating a safe space online</strong>. 
                    </p>

                    <p>
                        We have piecemeal defences. <strong>We need a safety net for the internet</strong>.
                    </p>


                    <p>
                        We're <strong>not arguing for a dismantling of the current internet</strong>. The internet will still be available. But <strong>for most, a safe version of the internet will suffice</strong>.
                    </p>

                    {/* <p>
                        Trust will be the next focus for the internet.
                    </p> */}

                    <p>
                        <strong>Let's make an internet we're proud of</strong>, for generations to come.
                    </p>

                    <p>
                        An internet <strong>without violence</strong>.
                    </p>

                    <p>
                        An internet <strong>without explicit content</strong>.
                    </p>

                    <p>
                        A web <strong>without abuse</strong>.
                    </p>

                    <p>
                        A web <strong>without harm</strong>.
                    </p>
                    
                    <p>
                        <strong>An enduring positive legacy</strong> for the internet.
                    </p>

                    <p>
                        <strong>A dream? It's not</strong>. <strong>It's already possible, if we want it</strong>. Let's join together and bring a safe internet into existence.
                    </p>

                    <p>
                        Why <strong>let previous inaction dictate the future?</strong>
                    </p>

                    <p>
                        We need a <strong>safety net</strong>.
                    </p>

                    {/* <p>
                        <strong>We need a safenet.</strong>
                    </p> */}

                    <p>
                        We need a <strong>trusted internet</strong>.
                    </p>

                    <p>
                        A net with only <strong>safe, trusted websites</strong>.
                    </p>

                    <p>
                        A <strong>trustnet</strong>.
                    </p>

                    

                    <p>
                        <strong>A net</strong>, not for some of us; <strong>for all of us</strong>.
                    </p>

                    





                    <p>
                        <strong>Hooked for a new net?</strong> Say, scream and shout <strong>Make The Net Safe</strong>. 
                    </p>
                    <p>
                        <strong>Join the movement</strong> and <strong>let's make the net safe</strong>.
                    </p>

                    <p>
                        In our online travels, <strong>we've collected examples of trust violations</strong>, instances where organisations break our trust assumptions and damage internet safety. We call them <strong>Trust Issues</strong> and you can <a href="https://launch.blog/"><strong>read them here <WebsiteIcon name="chevron-circle-right" fill /></strong></a>
                    </p>

                    <p>
                        <strong>PS.</strong> You can try what we think is a safer internet with the Epi link checker. <strong>Any website you land on</strong>, you can <strong>check it's safe</strong>. <br /><a href="https://launch.epi.app/confirm"><strong>Check a link <WebsiteIcon name="chevron-circle-right" fill /></strong></a>
                    </p>
                    <p>
                        <strong>PPS.</strong> The founders of this movement work on <strong>Epi</strong>, an organisation indexing only safe websites, and building a safer online future. <a href="https://epihq.com/"><strong>Read more <WebsiteIcon name="chevron-circle-right" fill /></strong></a>
                    </p>

                    <div className="MakeNetSafe-title">
                        <div>
                            Make
                        </div>
                        <div>
                            The
                        </div>
                        <div>
                            Net
                        </div>
                        <div>
                            Safe
                        </div>
                    </div>

                    
                </div>
            </div>
        )
    }
}

export default MakeNetSafe
